import BaseService from './BaseService';

const resource = 'api/v3/sap/?url=/api_scc_cc/';

class ContractorService extends BaseService {
  constructor() {
    super({ resource });
  }

  async get_contractor_info() {
    const action = 'contractor/get-data/';
    const response = await this.http.get(this.resource + action);
    return response.data;
  }

  async get_contractor_employees(userId, expiresOn, page, pageSize) {
    let params = `?page=${page}&page_size=${pageSize}`;

    if (expiresOn) {
      params += `&to-expire=${expiresOn}`;
    }

    const action = `contractor/${userId}/requested-card/${params}`;
    const response = await this.http.get(this.resource + action);
    return response.data;
  }
}

export default ContractorService;
